export const buildProvenance = { "commitHash": "d174cd56724c155496cf37f594350fdf7578ffe7", "branchName": "refs/heads/release/2024.2", "buildDate": "2024-09-04T16:38:05.003Z", "version": "2024.2.9441" };
